import {createContext} from 'react';

const SubmitDisabledContext = createContext<
  React.Dispatch<React.SetStateAction<boolean>>
>(() => {});

export default SubmitDisabledContext;
